export { default } from './info'
